import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { type MenuItem } from '@wix/da-ds/pkg/Dropdown/MenuList';
import { usePushSubscription } from '../../../../redux/pwa/hooks';
import { getPushPocEnabled } from '../../../../redux/pwa/selectors';
import { supportsDesktopWebPush } from '../../../../redux/pwa/helpers';
import { isPWA } from '../../../../utils/isPWA';
import { getIsMobile } from '../../../../publicSession/selectors';
import SuffixText from '../_partials/SuffixText';

export function usePushSubscriptionItem(): MenuItem | false {
  const { isSubscribed, isBlocked, manage } = usePushSubscription();
  const pushPocEnabled = useSelector(getPushPocEnabled);
  const isMobile = useSelector(getIsMobile);
  const { t } = useTranslation();
  const showDesktopPushItem = pushPocEnabled && supportsDesktopWebPush(isMobile);

  // Show the existing PWA entry as-is, or surface it on desktop behind push_poc.
  if (!isPWA() && !showDesktopPushItem) {
    return false;
  }

  return {
    label: t('siteHeader.userMenu.pwa.loggedIn.label'),
    suffix: (
      <SuffixText>
        {isBlocked
          ? t('siteHeader.userMenu.pwa.loggedIn.suffix.blocked')
          : isSubscribed
            ? t('siteHeader.userMenu.pwa.loggedIn.suffix.enabled')
            : t('siteHeader.userMenu.pwa.loggedIn.suffix.disabled')}
      </SuffixText>
    ),
    onClick: manage,
  };
}
